/**
 * Application Configuration Constants
 */

// Dictionary API configuration (Merriam-Webster Elementary)
export const MW_ELEMENTARY_API_KEY = '7f87b9ef-a8e8-4439-a80a-a4342b220f9a';
export const MW_ELEMENTARY_API_URL = 'https://www.dictionaryapi.com/api/v3/references/sd2/json';

// App configuration
export const APP_NAME = 'Svara';
export const APP_VERSION = '1.0.0';

// Feature flags
export const FEATURES = {
  PARENT_PORTAL: true,
  INVITES: true,
  ASSIGNMENTS: true,
  ANALYTICS: true,
  ADMIN_PORTAL: true,
} as const;
